import update from 'react-addons-update'

//* EVENTS */
const DISPLAY_ERROR = 'app/DISPLAY_ERROR'

export function displayError (error) {
  return {
    type: DISPLAY_ERROR,
    payload: error
  }
}

//* Reducers *//
export default function reducer (state = {
  errors: []
}, action) {
  switch (action.type) {
    case DISPLAY_ERROR: {
      return update(state, {errors: {$push: [action.payload]}})
    }

    default:
      return state
  }
};


// WEBPACK FOOTER //
// ./src/app/actions/app.js